module.exports = __webpack_public_path__ + "img/moving.bfdff30a.svg";